<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Fee Plan</p>
          </div>
        </div>
        <div v-if="isSuperAdmin" class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'UploadFeeComponent' }" class="button is-primary is-small btnicon" title="Upload">
              Upload
            </router-link>
          </div>
          <div class="level-item">
            <router-link :to="{ name: 'AddFeePlan' }" class="button is-info is-small btnicon" title="Add">
              Add
            </router-link>
          </div>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>
    <card-component>
      <div class="columns is-multiline">
        <div class="column ">
          <drop-down type="forAcadmicYear" @change="getFeeTypeList"></drop-down>
        </div>
        <div class="column is-6">
          <drop-down type="forFranchiseeSelection" @change="getFeeTypeList"></drop-down>
        </div>
      </div>
      <div class="is-main-section">
        <div class="columns">
          <div class="column"><span class=" tag is-primary circle ">E</span>&nbsp;&nbsp;&nbsp;-Existing Students</div>
          <div class="column"><span class="tag is-warning circle">LP</span>&nbsp;&nbsp;&nbsp;-Limited Period Plan</div>
          <div class="column"><span class="tag is-success circle">AD</span>&nbsp;&nbsp;&nbsp;- Depends on Admission Date</div>
        </div>

        <div class="columns">
          <div class="column"><span class=" circle " v-bind:class="getClass(true)">A</span>&nbsp;&nbsp;&nbsp;-Component Status Activate</div>
          <div class="column"><span class=" circle " v-bind:class="getClass(false)">IA</span>&nbsp;&nbsp;&nbsp;-Component Status Inactivate</div>
          <div class="column"><span class="tag is-link circle">N</span>&nbsp;&nbsp;&nbsp;-New Admission</div>
        </div>
      </div>
    </card-component>

    <section class=" ">
      <template v-if="feeTypeData.length > 0">
        <div v-for="feeData in feeTypeData" :key="feeData.id">
          <div class=" card-content">
            <div class="box content">
              <div class="columns" style="background-color:#FAFAFA">
                <div class="column customer_details p-t-10  m-l-15">
                  <table class="table is-fullwidth m-b-10 p-l-15">
                    <tr>
                      <th>Name :</th>
                      <td>{{ feeData && feeData.name ? feeData.name : '-' }}</td>
                    </tr>

                    <!-- <tr>
                      <th>Category:</th>
                      <td>{{ feeData.feeCategory && feeData.feeCategory.name ? feeData.feeCategory.name : '-' }}</td>
                    </tr> -->
                  </table>
                </div>
                <div class="column  customer_details p-t-10  m-l-15">
                  <table class="table is-fullwidth m-b-10 p-l-15">
                    <!-- <tr>
                      <th>Level :</th>
                      <td>{{ feeData.feeCategory && feeData.feeCategory.level ? feeData.feeCategory.level : '-' }}</td>
                    </tr> -->

                    <tr>
                      <th>Year :</th>
                      <td>{{ feeData.franchiseeAcademicYear && feeData.franchiseeAcademicYear.academicYear ? feeData.franchiseeAcademicYear.academicYear : '-' }}</td>
                    </tr>
                  </table>
                </div>
                <div class="column  customer_details p-t-10  m-l-15">
                  <table class="table is-fullwidth m-b-10 p-l-15">
                    <tr>
                      <th>Limited Start Date</th>
                      <td>
                        {{ feeData && feeData.startLimitedPeriod ? new Date(feeData.startLimitedPeriod).toLocaleDateString() : '-' }}
                      </td>
                    </tr>

                    <tr>
                      <th>Limited End Date</th>
                      <td>
                        {{ feeData && feeData.endLimitedPeriod ? new Date(feeData.endLimitedPeriod).toLocaleDateString() : '-' }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <hr class="hr" />
              <div class="columns">
                <div class="column is-2 ">
                  <label class="label">Franchisee</label>
                  <b-taglist>
                    <div v-for="fr in feeData.feeComponentFranchiseeMaps" :key="fr.franchiseeID">
                      <b-tag type="is-info is-light" size="is-medium" v-for="fr1 in fr.franchisees" :key="fr1.id">
                        {{ fr1.companyName }}
                      </b-tag>
                    </div>
                  </b-taglist>
                </div>
                <div class="column is-3">
                  <label class="label">Class</label>
                  <b-taglist>
                    <div v-for="fr1 in feeData.feeComponentClassMaps" :key="fr1.classID">
                      <div style="padding:3.5px">
                        <b-tag type="is-info is-light" size="is-medium" v-for="cl in fr1.studentClasses" :key="cl.id"> {{ cl.name }} </b-tag>
                      </div>
                    </div>
                  </b-taglist>
                </div>
                <div class="column">
                  <b-table :striped="true" :hoverable="true" :data="feeData.feeComponentFeeTypeMaps">
                    <template slot-scope="props">
                      <b-table-column label="FeeType " field="name" sortable centered>{{ props.row.feeType.name }} </b-table-column>

                      <b-table-column label="Amount " field="amount" sortable centered>
                        {{ props.row.amount }}
                      </b-table-column>

                      <b-table-column label="Settings " field="Settings" sortable centered>
                        <router-link
                          :to="{
                            name: 'AddFeeInstallment',
                            params: {
                              componentID: props.row.feeComponentID,
                              breakDownID: props.row.id
                            }
                          }"
                          class="button is-gray is-small btnicon"
                          title="Installment"
                        >
                          <b-icon icon="settings" size="is-small" />
                        </router-link>
                      </b-table-column>

                      <b-table-column label="Royalty Settings " field="Royalty Settings" sortable centered>
                        <router-link
                          v-if="props.row.feeType.isRoyalty"
                          :to="{
                            name: 'AddFeeRoyaltyInstallment',
                            params: {
                              componentID: props.row.feeComponentID,
                              breakDownID: props.row.id
                            }
                          }"
                          class="button is-gray is-small btnicon"
                          title="Royalty Installment"
                        >
                          <b-icon icon="settings" size="is-small" />
                        </router-link>
                      </b-table-column>
                      <b-table-column label="Select Fee Concession">
                        <div class="control">
                          <span class="select is-fullwidth" v-if="props.row.feeType.isRoyalty">
                            <select v-model="props.row.feeConcessionIDSelected" required @change="onChange($event, props.row)"
                              >/
                              <option :value="null">--Select--</option>
                              <option v-for="info in props.row.feeType.feeConcessions" :key="info.id" :value="info.id"> {{ info.name ? info.name : '' }}</option>
                            </select>
                          </span>
                        </div>
                      </b-table-column>
                    </template>
                    <template slot="footer">
                      <th>
                        <div class="has-text-centered">
                          <div>Total</div>
                        </div>
                      </th>
                      <th>
                        <div class="has-text-centered">
                          <div>{{ feeData.amount }}</div>
                        </div>
                      </th>
                      <th>
                        <div class="has-text-centered">
                          <div>Settings</div>
                        </div>
                      </th>
                      <th>
                        <div class="has-text-centered">
                          <div>Royalty Settings</div>
                        </div>
                      </th>
                      <th>
                        <div class="has-text-centered">
                          <div>Select Fee Concession</div>
                        </div>
                      </th>
                    </template>
                  </b-table>
                </div>
              </div>
              <div class="columns " style="background-color:#f1f1f1">
                <div class="column customer_details p-t-10 m-l-15">
                  <footer class="footer" style="background-color:#f4f6f6">
                    <div class="has-text-centered">
                      <span centered v-bind:class="getClass(feeData.isActive)" class="is-small is-capitalized circle "> {{ feeData.isActive ? 'A' : 'IA' }} </span> &nbsp;&nbsp;&nbsp;
                      &nbsp;&nbsp;&nbsp;
                      <span centered v-if="feeData.isNewStudent" class="tag is-link circle">N </span>
                      &nbsp;&nbsp;&nbsp;
                      <span centered v-if="feeData.isExistingStudent" class="tag is-primary circle">E</span>&nbsp;&nbsp;&nbsp;
                      <span centered v-if="feeData.isDependAdmissionDate" class="tag is-success circle">AD</span>&nbsp;&nbsp;&nbsp;
                      <span centered v-if="feeData.isLimitedPeriod" class="tag is-primary circle">LP</span> &nbsp;&nbsp;&nbsp;
                    </div>
                  </footer>
                </div>
                <div class="column ">
                  <footer class="footer" style="background-color:#f4f6f6">
                    <div class="has-text-centered">
                      <b-button type="is-danger" @click="deactivateSetting(feeData.id)" v-if="feeData.isActive && isSuperAdmin" outlined
                        ><b-icon icon="arrange-bring-forward" size="is-small" class="m-r-5 has-text-centered"></b-icon>In-Active</b-button
                      >
                      <b-button type="is-info" @click="restoreSetting(feeData.id)" v-if="!feeData.isActive && isSuperAdmin" outlined
                        ><b-icon icon="arrange-bring-forward" size="is-small" class="m-r-5 has-text-centered"></b-icon>Active</b-button
                      >
                    </div>
                  </footer>
                </div>
                <div class="column">
                  <footer class="footer" style="background-color:#f4f6f6">
                    <router-link :to="{ name: 'EditFeePlan', params: { planID: feeData.id } }" class=" is-link has-text-centered">
                      <div v-if="isSuperAdmin" class="has-text-centered">
                        <b-button type="is-info" outlined><b-icon icon="account-settings" size="is-small" class="m-r-5 has-text-centered"></b-icon>Edit</b-button>
                      </div></router-link
                    >
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>No Record here.</p>
          </div>
        </section>
      </template>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import store from '@/store'
import DropDown from '../../reusableComp/dropDown'
import stores from '@/stores'

export default {
  name: 'FeePlanList',
  components: {
    CardComponent,
    DropDown
  },
  data () {
    return {
      id: '',
      currentID: '',
      franchiseeArr: [],
      feeTypeData: [],
      academicYears: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      isCustom: false,
      tempFranchisee: ''
    }
  },

  async created () {
    // if (this.franchiseeIDMutiple.length > 0) {
    //   this.franchiseeID = this.franchiseeIDMutiple[0].id
    // }

    this.$store.dispatch('getCurrentAcadmicYearID')
    await this.getFeeTypeList()
  },
  watch: {
    franchiseeID: function (values) {
      if (!values) {
        this.total = 0
        this.feeTypeData = []
      }
    },
    academicYearID: function (values) {
      if (!values) {
        this.total = 0
        this.feeTypeData = []
      }
    }
  },

  computed: {
    gettersusers () {
      return this.$store.getters.academicYearResponse
    },
    users () {
      return this.$store.state.academicYearResponse
    },
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      }
    },
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    },
    franchiseeIDMutiple: {
      get () {
        return store.state.feeComponent.franchiseeIDMutiple
      }
    },
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  methods: {
    onChange (event, { id, feeConcessionID }) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to apply the changes for this fee type?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            /* deactive  */
            await http.patch(`${constants.API_URL}/api/fee-component-fee-concession/`, {
              academicYearID: that.academicYearID,
              franchiseeID: that.franchiseeID,
              feeConcessionID: event.target.value,
              feeComponentFeeTypeMapID: id
            })
            await that.getFeeTypeList()
            this.loadingComponent.close()

            return this.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Save Changes successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in deactivating Component : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        },
        onCancel: async () => {
          console.log('feeConcessionID--', feeConcessionID)
          event.target.value = ''
        }
      })
    },
    deactivateSetting: function (Id) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to deactivate Component?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            /* deactive  */
            await http.put(`${constants.API_URL}/api/fee-component-active/${Id}`, {
              isActive: false
            })
            await that.getFeeTypeList()
            this.loadingComponent.close()

            return this.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Component deactivated successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in deactivating Component : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    restoreSetting: function (Id) {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to restore Component?',
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()

            /* restore  */
            await http.put(`${constants.API_URL}/api/fee-component-active/${Id}`, {
              isActive: true
            })
            await that.getFeeTypeList()
            this.loadingComponent.close()

            return that.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Component restored successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage = (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in restoring  : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },
    getFeeTypeList: async function () {
      try {
        if (this.franchiseeID === '' || this.academicYearID === '') {
          return this.$buefy.toast.open({
            message: 'Please select below details',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          if (this.academicYearID || this.franchiseeID) {
            let payload = {}
            if (this.academicYearID) {
              payload.academicYearID = this.academicYearID
            }
            if (this.franchiseeID) {
              payload.franchiseeID = this.franchiseeID
            }
            this.loadingComponent = this.$buefy.loading.open()
            let response = await http.get(`${constants.API_URL}/api/fee-component`, {
              params: payload
            })
            this.feeTypeData = response.data
            this.feeTypeData.forEach(element => {
              element.feeComponentFeeTypeMaps.forEach(item => {
                item.feeConcessionIDSelected = item.feeConcessionID
              })
            })
            console.log('the--', this.feeTypeData)
            this.loadingComponent.close()
          }

          if (!this.feeTypeData) {
            this.total = 0
          } else {
            this.total = this.feeTypeData.length
          }
        }
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClass: function (isActive) {
      return !isActive ? 'tag is-danger' : 'tag is-success'
    }
  }
}
</script>

<style scoped>
.buttons {
  flex-wrap: nowrap;
}
th {
  background-color: #f4f6f6;
}
td {
  background-color: #f4f6f6;
}

.circle {
  background-color: red;
  width: 30px;
  height: 30px;
  border-radius: 30px;
}
.p-t-10 {
  padding-top: 15px !important;
}
.b-table .table td,
.b-table .table td {
  border: 1px solid #bfbfbf !important;

  background-color: white;
}
.hr {
  background-color: #f1f1f1;
  border: none;
  display: block;
  height: 2px;
  margin: 10px;
}
.box {
  box-shadow: 0 1px 1px 2px rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
}
</style>
